import styled from '@/styles';

export const GRID_COLUMNS =
  '36px minmax(210px, 1.1fr) minmax(210px, 1.1fr) minmax(230px, 1.4fr) 56px 56px 110px 190px 130px 90px';

export const GridRow = styled('div', {
  display: 'grid',
  gridTemplateColumns: GRID_COLUMNS,
  gap: '12px',
  padding: '12px 20px',
  borderTop: '1px solid #F0F0F0',
  minWidth: '1280px',
  alignItems: 'start',
  fontSize: '14px',
  variants: {
    head: {
      true: {
        borderTop: '1px solid #EDEDED',
        background: '#FAFAFA',
        fontSize: '12px',
        fontWeight: 600,
        color: '#5A5A5A',
        textTransform: 'uppercase',
        alignItems: 'center',
      },
    },
    open: { true: { background: '#F6FBF6' } },
  },
});

export const Cell = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '6px',
  alignItems: 'flex-start',
  minWidth: 0,
});

export const GroupChip = styled('span', {
  display: 'inline-flex',
  padding: '3px 8px',
  borderRadius: '6px',
  fontSize: '12px',
  fontWeight: 600,
  variants: {
    group: {
      profile: { background: '#E3EDFB', color: '#1A4C93' },
      compliance: { background: '#F1E6FA', color: '#62298A' },
      activation: { background: '#E7F4E6', color: '#17722F' },
      retention: { background: '#FCE9DA', color: '#8C4209' },
    },
  },
});

export const StepChip = styled('span', {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '5px',
  padding: '3px 8px',
  border: '1px solid #E3E3E3',
  borderRadius: '6px',
  fontSize: '12px',
  background: '#FFFFFF',
});

export const Chevron = styled('button', {
  width: '28px',
  height: '28px',
  border: 'none',
  background: 'none',
  cursor: 'pointer',
  borderRadius: '6px',
  '&:hover': { background: '#EDEDED' },
  '& svg': { transition: 'transform 0.15s' },
  '&[aria-expanded="true"] svg': { transform: 'rotate(90deg)' },
});

export const NameButton = styled('button', {
  border: 'none',
  background: 'none',
  padding: 0,
  font: 'inherit',
  fontSize: '15px',
  textAlign: 'left',
  cursor: 'pointer',
  color: '#1E1E1E',
});

export const SwitchButton = styled('button', {
  position: 'relative',
  width: '36px',
  height: '20px',
  borderRadius: '10px',
  border: 'none',
  background: '#C4C4C4',
  cursor: 'pointer',
  padding: 0,
  '&::after': {
    content: '""',
    position: 'absolute',
    top: '2px',
    left: '2px',
    width: '16px',
    height: '16px',
    borderRadius: '50%',
    background: '#FFFFFF',
    transition: 'left 0.15s',
  },
  '&[aria-checked="true"]': { background: '#1E8E3E' },
  '&[aria-checked="true"]::after': { left: '18px' },
  '&:disabled': { opacity: 0.55, cursor: 'default' },
});

export const Muted = styled('span', { fontSize: '13px', color: '#5A5A5A' });

export const ErrorText = styled('span', {
  fontSize: '13px',
  fontWeight: 600,
  color: '#B0030A',
});

export const DetailWrap = styled('div', {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
  gap: '20px',
  background: '#FAFAFA',
  borderTop: '1px solid #EDEDED',
  padding: '18px 20px 22px 56px',
  minWidth: '1280px',
});

export const Block = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
  padding: '16px',
  background: '#FFFFFF',
  border: '1px solid #DADADA',
  borderRadius: '8px',
  '& h3': { margin: 0, fontSize: '15px' },
});

export const ReasonLine = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  gap: '12px',
  borderBottom: '1px dashed #E3E3E3',
  padding: '3px 0',
});

export const Button = styled('button', {
  padding: '8px 14px',
  border: '1px solid #DADADA',
  borderRadius: '6px',
  background: '#FFFFFF',
  fontSize: '14px',
  fontWeight: 600,
  cursor: 'pointer',
  '&:disabled': { opacity: 0.55, cursor: 'default' },
  variants: {
    primary: {
      true: { background: '#1E8E3E', borderColor: '#1E8E3E', color: '#FFFFFF' },
    },
  },
});
